<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-button type="primary" @click="add" :style="{ margin: '0 0 24px 0' }">
      投币数量设置
    </a-button>
    <a-modal v-model="visible" title="投币数量设置" @ok="handleOk">
      <div class="modal">
        <!-- <span>套餐价格：</span
        ><a-input
          v-model="formData.packageMoney"
          class="packageName"
          placeholder="请输入"
        />
        <span>套餐名：</span
        ><a-input
          v-model="formData.packageName"
          class="packageName"
          placeholder="请输入"
        /> -->
        <span>投币数：</span
        ><a-input v-model="formData.coinsNum" placeholder="请输入" />
      </div>
    </a-modal>
    <a-modal v-model="visibletwo" title="编辑投币数量" @ok="handleOktwo">
      <div class="modal">
        <!-- <span>套餐价格：</span
        ><a-input
          v-model="formDatatwo.packageMoney"
          class="packageName"
          placeholder="请输入"
        />
        <span>套餐名：</span
        ><a-input
          v-model="formDatatwo.packageName"
          class="packageName"
          placeholder="请输入"
        /> -->
        <span>币数：</span
        ><a-input v-model="formDatatwo.coinsNum" placeholder="请输入" />
      </div>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="middle"
    >
      <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template>
      <template slot="operation" slot-scope="text, operation">
        <a href="javascript:;" @click="deit(operation)">编辑</a>
        <a href="javascript:;" @click="del(operation)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  storeCoinnum,
  storeCoinnumAdd,
  storeCoinnumUpdate,
  storeCoinnumDel,
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
  },
  {
    title: "套餐名",
    dataIndex: "packageName",
  },
  {
    title: "套餐价格",
    dataIndex: "packageMoney",
  },
  {
    title: "币数",
    dataIndex: "coinsNum",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    sorter: true,
  },
  {
    title: "操作",
    dataIndex: "operation",
    sorter: true,
    scopedSlots: { customRender: "operation" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      visibletwo: false,
      formData: {
        coinsNum: "",
        packageMoney: null,
        packageName: "",
      },
      formDatatwo: {
        objId: "",
        coinsNum: "",
        packageMoney: "",
        packageName: "",
      },
    };
  },
  mounted() {
    this.getStoreCoinnum();
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      storeCoinnum({ limit: 10, page: this.pagination.current }).then((res) => {
        this.data = res.data;
        this.loading = false;
      });
    },
    getStoreCoinnum() {
      storeCoinnum({
        pageSize: 10,
        pageNo: 1,
      }).then((res) => {
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    add() {
      this.visible = true;
      this.formData = { coinsNum: "", packageMoney: null, packageName: "" };
    },
    handleOk() {
      if(Number(this.formData.coinsNum) > 9999){
        return message.error('投币数最大不能超过9999')
      }
      this.visible = false;
      this.loading = true;
      storeCoinnumAdd(this.formData).then((res) => {
        this.getStoreCoinnum();
        message.success(res.info);
        this.loading = false;
      });
    },
    deit(row) {
      console.log(row);
      this.visibletwo = true;
      this.formDatatwo.objId = row.objId;
      this.formDatatwo.coinsNum = row.coinsNum;
      this.formDatatwo.packageMoney = row.packageMoney;
      this.formDatatwo.packageName = row.packageName;
    },
    handleOktwo() {
      if(Number(this.formDatatwo.coinsNum) > 9999){
        return message.error('投币数最大不能超过9999')
      }
      this.visibletwo = false;
      storeCoinnumUpdate(this.formDatatwo).then((res) => {
        this.getStoreCoinnum();
        message.success(res.info);
      });
    },
    del(row) {
      this.loading = true;
      storeCoinnumDel({ objId: row.objId }).then((res) => {
        this.getStoreCoinnum();
        message.success(res.info);
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.packageName {
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/coinnum/coinnumHome.vue